import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Plan } from "../../domain/models/plan";
import { PlansRepository } from "../../repositories";
import { Observable } from 'rxjs';
import { ClonePlanRequest } from "../../domain/requests/plans/clone-plan.request";

@Injectable({ providedIn: 'root' })
export class ClonePlanUsecase implements UseCase<ClonePlanRequest, Plan> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: ClonePlanRequest): Observable<Plan> {
    return this.planRepository.clonePlan(params);
  }
}
